import React from 'react';
import { connect }  from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import CardMedia from '@material-ui/core/CardMedia';
import { PropTypes } from 'prop-types';

//import { StyleSheet,  View, Image, Text, TextInput,Dimensions } from 'react-native';
//import { Paper,RaisedButton, IconToggle, Icon, themes, FloatingActionButton,} from 'carbon-ui'
import { platformHandler } from '../platforms/PlatformHandler'
import {FwScene} from './FwScene'
//import { em, sizeResponsive, sizeResponsiveLandscape, getValuePlatform, getX, getY } from "../utils/FWResponsive";
//import { COLOR, FONT_FAMILY, TEXT_SIZES }           from '../constants/Constants';
//import Loader from '../components/flipwitComponents/Loader';

const styles = theme => ({  
	flipwitContent: {
	    height:'calc(100% - 30px)',
	    display: 'flex',    
	    //justifyContent: 'center',
	    alignItems: 'center',
	    flexWrap: 'nowrap',    
	    flexDirection: 'column',     
	    width: '100%',
	    alignSelf: 'flex-start',
    	marginTop: 32,

		'@media (orientation: landscape)': {
	      	flexDirection: 'row',
	    }	    
	},  

	imgContainer: {
		width: '100%',
		height: '100%',
		maxWidth: 1280,
	},

	media: {
		width: '100%',  		
    	height: '100%',
    	backgroundSize: 'contain',
    	position: 'relative',
    	display: 'flex',
    	alignItems: 'center',
	}, 	

	slideImgContainer: {
		//height: 'calc(100% - 50px)',
		//borderBottom: '1px solid #AAA',		
		backgroundColor: '#EEEEEE',		
		display: 'flex',
		position: 'relative',
		filter: 'drop-shadow(0px 0px 1px rgba(0,0,0,0.3)) drop-shadow(0px 0px 10px rgba(0,0,0,0.3))',
		height: "calc(100% - 200px)",

		'@media (orientation: landscape)': {
	      	height: "calc(100% - 50px)",
	    }	
	},	

	allContainers: {
		//width: '96%',
		backgroundColor: 'white',
		borderBottom: '1px solid #AAA',		
	},

	bigBoxContainers: {
		//margin: '5px', 
		height: '100%',
    	width: '100%',
    	display: 'flex',
    	flexDirection: 'column',
        justifyContent: 'center',
		borderBottom: '1px solid #AAA',	
        //height: 'auto',

		'@media (orientation: landscape)': {
	      	flexDirection: 'row',
	    }	
	},
});

class WaitingSession extends FwScene {
	componentWillUnmount() {
		clearInterval(this.intervalCheckHeight);
	}

	componentDidMount() {
		platformHandler.checkTitleBarScene("WaitingSession");
		this.intervalCheckHeight = setInterval( this.checkSession, 4000);
	}

	checkSession = () =>{
		platformHandler.joinPresentation( window.codeByUrl, this.callback );
	}

	callback = ( data ) =>{
		if( data.success ){
			if( data.resp ){
				platformHandler.sceneManager.openScene("Role");
			}
		}
	}

	state = {
	    showLoader: true
	}

	paintVisor(){
		console.log('estamos en WaitingSession ' , this.props.history.location.state.urlWait)
		const { classes } = this.props;		

		return (
			<div id="imgContainer" className={classes.imgContainer} >
				<CardMedia
					id="imgWaitingSession"
		        	className={classes.media}
		        	image={this.props.history.location.state.urlWait}
		        >
				</CardMedia>
			</div>
		);

		/*return (
			<Image 	source={{uri: this.props.urlWait}} ref={(child) => { this.imageComp = child; }}
					style={styles.imagePreviewInt}
					resizeMode={'contain'}
					onLoad={this.onHandleReady}>
			</Image>
		);*/
	}

	onHandleReady = (e) => {
	    this.setState({ showLoader:false }) 
	}

	render() {
		const { classes } = this.props;
    	let contentPreview = this.paintVisor();

    	return ( 
	    	<div className={classes.flipwitContent} ref={(child) => { this.mainDiv = child; }}>
	    		<div className={[classes.allContainers,classes.bigBoxContainers].join(' ')}>
	    			{contentPreview}
	    		</div>						
	    	</div>
	    );
    	
    	/*
    	return(
    		<View style={styles.container} ref={(child) => { this.imageCont = child; }}>
				<View style={styles.innerContainer} ref={(child) => { this.fullImage = child; }}>
					<View style={styles.containerContent}>
						{contentPreview}
						<Loader active={this.state.showLoader}/>
					</View>		
				</View>	
			</View>
		);	*/
    }
}

WaitingSession.contextTypes = {
  store: PropTypes.object
};

WaitingSession.propTypes = {
  classes: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,
  history: PropTypes.object,
};

const mapStateToProps = state => {  	
  return {
  	language: state.containers.appReducer.language,    
  }
};


export default connect(mapStateToProps)(withStyles(styles,{ withTheme: true })(WaitingSession));



// WEBPACK FOOTER //
// ./src/containers/scenes/WaitingSession.js